import { render, staticRenderFns } from "./swPostQuestion.vue?vue&type=template&id=97f4ad64&"
import script from "./swPostQuestion.vue?vue&type=script&lang=js&"
export * from "./swPostQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports